import { loadTranslation } from '@confluence/i18n/entry-points/translation';
import type { LocalizationMessages } from '@confluence/i18n/entry-points/LocalizationMessages';

import {
	WATERFALL_INITIAL_MEASURES,
	WaterfallMeasures,
} from '@confluence/action-measures/entry-points/WaterfallMeasures';

import { lazyLanguage } from './i18n/lazy-language';

let translationPromise: Promise<void> | null = null;

export async function tryLoadTranslation(): Promise<void> {
	if (translationPromise === null) {
		translationPromise = WaterfallMeasures.run(
			WATERFALL_INITIAL_MEASURES.BOOTSTRAP_TRANSLATION,
			() =>
				loadTranslation(
					lazyLanguage as unknown as (locale: string) => Array<Promise<LocalizationMessages>>,
				),
		);
	}
	return translationPromise;
}
